module.exports = __webpack_public_path__ + "static/media/generic-tech-icon.995d44e0.svg";